import { Pipe, PipeTransform } from "@angular/core";
import { nonNullish } from "src/guards";

@Pipe({
  name: "googleMapsLink",
})
export class GoogleMapsLinkPipe implements PipeTransform {
  transform(queryParams: (string | null | undefined)[]): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      queryParams.filter(nonNullish).join(" "),
    )}`;
  }
}
